export const isAllowedOrigin = (origin: string) => {
  const local = /^https:\/\/[\w-]+\.local\.olkypay\.local:5173$/;
  const dev = /^https:\/\/[\w-]+\.dev\.olkypay\.local$/;
  const uat = /^https:\/\/[\w-]+\.uat\.olkypay\.com$/;
  const prod = /^https:\/\/[\w-]+\.olky\.eu$/;

  if (process.env.NODE_ENV === "production") {
    return prod.test(origin) || uat.test(origin) || dev.test(origin);
  }
  return local.test(origin);
};
